import ModelVersionService from '@/services/modelVersions';
import DeviceService from 'src/services/device';
import {
  getDeviceDisplayNameToSerialNumMap,
  getDeviceIdToNameMap,
  getDeviceIdToSerialNumMap,
  getDeviceSerialNumToDisplayNameMap,
} from 'src/utils/device';
import types from '../mutation-types';

const state = {
  selectedTaskForDetail: {},
  taskCropParams: {},
  devices: [],
  activeDevices: [],
  isFetchingDevices: false,
  deviceSerialNumToDisplayNameMap: {},
  deviceDisplayNameToSerialNumMap: {},
  deviceIdToNameMap: {},
  deviceIdToSerialNumMap: {},
  cachedMonitoringStatuses: [],
  allDevices: [],
  selectedDeviceTasks: [],
  modelVersions: [],
  taskTags: [],
  startedDevice: null,
};

const getters = {
  selectedTaskForDetail: (state) => state.selectedTaskForDetail,
  taskCropParams: (state) => state.taskCropParams,
  devices: (state) => state.devices,
  cachedActiveDevices: (state) => state.activeDevices,
  cachedMonitoringStatuses: (state) => state.cachedMonitoringStatuses,
  isFetchingDevices: (state) => state.isFetchingDevices,
  deviceSerialNumToDisplayNameMap: (state) =>
    state.deviceSerialNumToDisplayNameMap,
  deviceDisplayNameToSerialNumMap: (state) =>
    state.deviceDisplayNameToSerialNumMap,
  deviceIdToNameMap: (state) => state.deviceIdToNameMap,
  deviceIdToSerialNumMap: (state) => state.deviceIdToSerialNumMap,
  allDevices: (state) => state.allDevices,
  selectedDeviceTasks: (state) => state.selectedDeviceTasks,
  modelVersions: (state) => state.modelVersions,
  taskTags: (state) => state.taskTags,
};

const actions = {
  async setActiveDevices({ commit }) {
    const [error, data] = await DeviceService.getActiveDeviceStatus();
    if (error) {
      console.log(error);
      return;
    }
    commit(types.SET_ACTIVE_DEVICES, data);
    return [error, data];
  },

  async getTagsDevices({ commit }, taskId) {
    let [err, data] = await DeviceService.getTagsDevices(taskId);
    // set video tags
    commit(types.SET_TASK_TAGS, data);
    return [err, data];
  },

  async setNewTags({ commit }, data) {
    // set video tags
    let isDataExist = state.taskTags.find(
      (eachTag) => eachTag.tag_value == data.tag_value
    );
    if (isDataExist) {
      return;
    }
    commit(types.SYNC_TASK_TAGS, data);
  },

  async setMonitoringStatus({ commit }) {
    const [error, data] = await DeviceService.getMonitoringStatus();
    if (error) {
      console.log(error);
      return;
    }
    commit(types.SET_MONITORING_STATUS, data);
    return [error, data];
  },
  setDeviceForDetail({ commit }, payload) {
    commit(types.SET_DEVICE_FOR_DETAIL, payload);
  },

  setTaskCropParams({ commit }, payload) {
    commit(types.SET_TASK_CROP_PARAMS, payload);
  },

  resetDeviceState({ commit }) {
    commit(types.RESET_DEVICE_STATE);
  },

  async getTaskDevices({ commit }, taskId) {
    let [error, data] = await DeviceService.getTaskDevices(taskId);
    if (error) {
      console.log(error);
      return;
    }
    commit(types.SET_DEVICE_TASKS, data);
  },

  async getTaskModelVersions({ commit }, taskId) {
    let [error, data] = await ModelVersionService.getModelVersionList({
      task: taskId,
    });
    if (error) {
      console.log(error);
      return;
    }
    commit(types.SET_DEVICE_MODEL_VERSIONS, data);
    return data;
  },

  async starredDevices({ commit }, payload) {
    let devices = state.devices.map((data) => {
      if (data.id == payload.id) {
        return { ...data, starred: payload.starred, active: true };
      }
      return data;
    });

    commit(types.SET_DEVICES, devices);
  },

  async getOrgDevices({ commit }, orgName) {
    console.log('typeof orgName:: ', typeof orgName);
    if (typeof orgName == 'string') {
      orgName = { orgName, isArchived: false };
    }

    commit(types.SET_IS_FETCHING_DEVICES, true);
    const [error, data] = await DeviceService.fetchAllDevicesOfOrg(
      orgName.orgName,
      false,
      { archived: orgName.isArchived }
    );
    commit(types.SET_DEVICES_DATA, data);
    commit(types.SET_IS_FETCHING_DEVICES, false);
    if (error) {
      console.log({ error });
      return;
    }
    const devices = data.filter(
      (device) => device.Type !== 'departmental device'
    );
    commit(types.SET_DEVICES, devices);
    commit(
      types.SET_DEVICE_SERIAL_NUM_TO_DISPLAY_NAME_MAP,
      getDeviceSerialNumToDisplayNameMap(devices)
    );
    commit(
      types.SET_DISPLAY_NAME_TO_DEVICE_SERIAL_NUM_MAP,
      getDeviceDisplayNameToSerialNumMap(devices)
    );
    commit(types.SET_DEVICE_ID_TO_NAME_MAP, getDeviceIdToNameMap(devices));
    commit(
      types.SET_DEVICE_ID_TO_DEVICE_SERIAL_NUM_MAP,
      getDeviceIdToSerialNumMap(devices)
    );
  },
};

const mutations = {
  [types.RESET_DEVICE_STATE](state) {
    (state.selectedTaskForDetail = {}),
      (state.taskCropParams = {}),
      (state.devices = []),
      (state.activeDevices = []),
      (state.isFetchingDevices = false),
      (state.deviceSerialNumToDisplayNameMap = {}),
      (state.deviceDisplayNameToSerialNumMap = {}),
      (state.deviceIdToNameMap = {}),
      (state.deviceIdToSerialNumMap = {}),
      (state.cachedMonitoringStatuses = []),
      (state.allDevices = []);
  },
  [types.SET_TASK_TAGS](state, payload) {
    state.taskTags = payload;
  },
  [types.SYNC_TASK_TAGS](state, payload) {
    state.taskTags = [...state.taskTags, payload];
  },
  [types.SET_MONITORING_STATUS](state, payload) {
    state.cachedMonitoringStatuses = payload;
  },
  [types.SET_IS_FETCHING_DEVICES](state, payload) {
    state.allDevices = payload;
  },
  [types.SET_DEVICE_FOR_DETAIL](state, payload) {
    state.selectedTaskForDetail = payload;
  },
  [types.SET_DEVICES_DATA](state, payload) {
    state.allDevices = payload;
  },
  [types.SET_TASK_CROP_PARAMS](state, payload) {
    state.taskCropParams = payload;
  },
  [types.SET_DEVICE_MODEL_VERSIONS](state, payload) {
    state.modelVersions = payload;
  },
  [types.SET_DEVICE_TASKS](state, payload) {
    state.selectedDeviceTasks = payload;
  },
  [types.SET_DEVICES](state, payload) {
    state.devices = payload;
  },
  [types.SET_ACTIVE_DEVICES](state, payload) {
    state.activeDevices = payload;
  },
  [types.SET_IS_FETCHING_DEVICES](state, payload) {
    state.isFetchingDevices = payload;
  },
  [types.SET_DEVICE_SERIAL_NUM_TO_DISPLAY_NAME_MAP](state, payload) {
    state.deviceSerialNumToDisplayNameMap = payload;
  },
  [types.SET_DISPLAY_NAME_TO_DEVICE_SERIAL_NUM_MAP](state, payload) {
    state.deviceDisplayNameToSerialNumMap = payload;
  },
  [types.SET_DEVICE_ID_TO_NAME_MAP](state, payload) {
    state.deviceIdToNameMap = payload;
  },
  [types.SET_DEVICE_ID_TO_DEVICE_SERIAL_NUM_MAP](state, payload) {
    state.deviceIdToSerialNumMap = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
